module.exports = __webpack_public_path__ + "google.svg?bb9d8d9697bbc7c1632674332550f765";